module.exports = __webpack_public_path__ + "img/6.3173a819.png";